// Copyright (c) 2017 Deere & Company

const metricCriteria = selectedMetrics =>
    selectedMetrics.length > 1 ? 'B' : selectedMetrics[0].key;

/* eslint-disable complexity, max-params */

export const buildPayload = (payloadParams, pipFilter, exportToExcel = '', language = '', listId = '', layoutName = '') => ({
    accounts: payloadParams.dealerAccountsFacet.selectedDealers.map(dealer => dealer.account),
    excludedPin: payloadParams.showExcludedFacet ? payloadParams.showExcludedFacet.selectedExcluded.key : '',
    export: exportToExcel,
    language,
    layout: layoutName,
    listId,
    metric: payloadParams.metricsFacet ? metricCriteria(payloadParams.metricsFacet.selectedMetrics) : '',
    pipFilter,
    pipType: payloadParams.pipTypesFacet ? payloadParams.pipTypesFacet.selectedTypes.map(pipType => pipType.key) : []
});

/* eslint-enable complexity, max-params */



// WEBPACK FOOTER //
// ./src/pip/shared/services/build-payload.js